// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type EcoRecommendations,
    EcoRecommendationsFromJSON,
    EcoRecommendationsToJSON,
} from '../models/EcoRecommendations';
import {
    type EcoStats,
    EcoStatsFromJSON,
    EcoStatsToJSON,
} from '../models/EcoStats';

export interface GetRoomRecommendationsRequest {
    /**
     * Room ID
     */
    roomId: string;
}

export interface GetRoomStatsRequest {
    /**
     * Room ID
     */
    roomId: string;
}

/**
 * 
 */
export class EcoApi extends runtime.BaseAPI {

    /**
     * Creates request options for getRoomRecommendations without sending the request
     */
    async getRoomRecommendationsRequestOpts(requestParameters: GetRoomRecommendationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roomId'] == null) {
            throw new runtime.RequiredError(
                'roomId',
                'Required parameter "roomId" was null or undefined when calling getRoomRecommendations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/eco/{roomId}/recommendations`;
        urlPath = urlPath.replace('{roomId}', encodeURIComponent(String(requestParameters['roomId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve eco recommendations for a specific room
     * Get eco recommendations for a room
     */
    async getRoomRecommendationsRaw(requestParameters: GetRoomRecommendationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EcoRecommendations>> {
        const requestOptions = await this.getRoomRecommendationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EcoRecommendationsFromJSON(jsonValue));
    }

    /**
     * Retrieve eco recommendations for a specific room
     * Get eco recommendations for a room
     */
    async getRoomRecommendations(requestParameters: GetRoomRecommendationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EcoRecommendations> {
        const response = await this.getRoomRecommendationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getRoomStats without sending the request
     */
    async getRoomStatsRequestOpts(requestParameters: GetRoomStatsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['roomId'] == null) {
            throw new runtime.RequiredError(
                'roomId',
                'Required parameter "roomId" was null or undefined when calling getRoomStats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/eco/{roomId}/stats`;
        urlPath = urlPath.replace('{roomId}', encodeURIComponent(String(requestParameters['roomId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve eco statistics for a specific room
     * Get eco stats for a room
     */
    async getRoomStatsRaw(requestParameters: GetRoomStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EcoStats>> {
        const requestOptions = await this.getRoomStatsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EcoStatsFromJSON(jsonValue));
    }

    /**
     * Retrieve eco statistics for a specific room
     * Get eco stats for a room
     */
    async getRoomStats(requestParameters: GetRoomStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EcoStats> {
        const response = await this.getRoomStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
